<template>
  <div class="phone-box" :class="{ 'phone-loading': loading }">
    <div class="new-popupbox box-loading" v-if="loading">
      <a-spin tip="正在读取教材内容，请稍后..." size="large" wrapperClassName="box-spin" />
    </div>
    <!-- 具体内容 -->
    <div class="phone-content-box">
      <a-empty class="empty-box" :image="simpleImage" v-if="intList.length == 0" />

      <phoneTopNav :hideBar="hideBar" :bar="bar"></phoneTopNav>

      <!-- 具体内容 -->
      <div class="phone-content">
        <div class="int-item" :id="int.PK_InductionGuid" :class="{ 'active': int.chapter_num == chapter_num }"
          v-for="int in intList">
          <!-- id和textbookContent必传 -->
          <!-- noteUpdated事件触发表示笔记 -->
          <TextbookRender ref="textbookRenderRef" class="textbook-item" :textbookData="int" isPhone
            @noteUpdated="handleNoteUpdated()" v-if="int.show && int.TextbookContent" />
        </div>
      </div>
    </div>
    <phoneBar :hideBar="hideBar" :bar="bar" :chapter_num="chapter_num" :intList="intList"
      @switchChapter="switchChapter($event, 'chapter')" @openCode="openCode($event)"
      @clickTextContent="clickTextContent($event)" @showBar="hideBar = $event" @chooseChildNav="chooseChildNav($event)">
    </phoneBar>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { PASSPORT_CLIENT_SERVER } from '@/config/url';

import phoneBar from '@/components/phone/phone-bar/phone-bar.vue';
import phoneTopNav from '@/components/phone/phone-top-nav/phone-top-nav.vue';
import TextbookRender from '@/components/list/textbook-list/TextbookRender/index.vue';


export default {
  name: 'textbook-phone',
  components: {
    TextbookRender,
    LoadingOutlined, phoneBar, phoneTopNav
  },
  props: {
    intList: Array,
    stuList: Array,
  },
  data() {
    return {
      navFold: true,
      navMax: false,
      hideBar: false,
      chapter_num: null,
      loading: true,

      logo_icon: require("@/assets/images/phone/icon.png"),
      logo_text: require("@/assets/images/phone/icon-text.png"),
      fromType: "",
      platform_type: '',

      platform: null,
      userInfo: {},

      bar: {
        show_nav: false,
        show_npc: false,
        show_achievement: false
      },

      needRouterPara: null,
      needRouterElement: null,

      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    }
  },
  mounted() {
    let { platform, userInfo, fromType } = this.$store.state;

    this.theme_color = platform.pageConfig.theme_color;
    this.userInfo = userInfo;
    this.platform = platform;
    this.fromType = fromType;
    this.platform_type = platform.Type;

    if (fromType != "yuanxi") {
      this.logo_icon = platform.pageConfig.logo;
      this.logo_text = '';
    }

    let that = this;
    setTimeout(() => {
      $('.scroll-box').scroll(function () {
        if (!that.loading) {
          if ($(`.scroll-box`).scrollTop() == 0) that.hideBar = false;
          else if (($(`.scroll-box`).scrollTop() + $(`.scroll-box`).height()) == $(`.phone-box`).height()) that.hideBar = false;
          else that.hideBar = true;
        }
      })
    }, 3000)


    if (this.intList.length == 0) return this.loading = false;
    this.switchChapter(0, 'chapter');
  },
  methods: {
    //监听菜单点击
    chooseChildNav(data) {
      let { intId, id } = data;
      this.needRouterElement = id;
      let currentInt = this.intList[this.chapter_num];
      if (intId && intId != currentInt.PK_InductionGuid) {
        let chapter_num = this.intList.findIndex(item => item.PK_InductionGuid == intId);
        if (chapter_num != null) this.switchChapter(chapter_num, 'chapter');
      }
      else this.routerElement();

    },
    //跳转段落
    routerElement() {
      if (!this.needRouterElement) return;
      let that = $(`[data-id=${this.needRouterElement}]`);
      if (that && that.offset()) {

        let scrollTop = $(`.scroll-box`).scrollTop() + that.offset().top - 80;
        $('.scroll-box').animate({ scrollTop }, 300);
        this.needRouterElement = null;
      }
    },

    //切换章节
    switchChapter(num, type) {
      let chapter_num = this.chapter_num;
      if (num == chapter_num) {
        if (this.needRouterElement) this.routerElement();
        else $('.scroll-box').animate({ scrollTop: 0 })
        return
      }

      this.loading = true;
      this.chapter_num = num;

      this.$nextTick(() => {
        //是否需要加载章节
        this.loadChapter(num);

        //是否需要加载内容
        this.intList.forEach((int, i) => {
          if (i == num) {
            this.loading = false;
            if (this.needRouterElement) setTimeout(() => { this.routerElement() }, 100);
            else if (type == 'chapter') $('.scroll-box').animate({ scrollTop: 0 })
          }
        })
      })
    },

    //加载前后章节
    loadChapter(num) {
      this.intList.forEach(int => { int.show = false })
      this.intList[num].show = true;
    },

    //判断用户是否在线
    async judgeOnline() {
      const ret = await this.$api.unifydata.verifyToken({ token: this.userInfo.token });
      if (ret.statusCode != 200) location.href = `${PASSPORT_CLIENT_SERVER}/yuanxi?redirectURI=${location.href}`;
    },

    ///////////////////////////菜单
    //滚动到code
    scrollTo(id) {
      this.$nextTick(async () => {
        let that = $(`[data-push-id=${id}]`);
        if (that) {
          let scrollTop = $(`.scroll-box`).scrollTop() + that.offset().top - 100;
          $('.scroll-box').animate({ scrollTop }, 300);
          that.children('.app-view-header').click();
        }
      })
    },
    //打开code
    openCode(code) {
      //是否加载章节并跳转
      let chapter_num = code.chapter_num;
      if (this.chapter_num != chapter_num) {
        this.switchChapter(chapter_num, 'code');

        this.intList.forEach((int, i) => {
          if (i == chapter_num) {
            if (int.loadFinish) this.scrollTo(code.Guid);
            else setTimeout(() => { this.scrollTo(code.Guid) }, 3000);
          }
        })
      }
      else this.scrollTo(code.Guid);
    },
    //监听菜单点击
    clickTextContent(data) {
      let { intId, target } = data;
      let that = this;
      if (target.tagName == 'H1' || target.tagName == 'H2' || target.tagName ==
        'H3' || target.tagName == 'H4' || target.tagName == 'H5' || target
          .tagName == 'H6') {
        let id = $(target).attr('data-id').replaceAll('\\"', '');
        this.needRouterPara = id;
        let currentInt = that.intList[that.chapter_num];
        if (intId && intId != currentInt.PK_InductionGuid) {
          let chapter_num = that.intList.findIndex(item => item.PK_InductionGuid == intId);
          if (chapter_num != null) this.switchChapter(chapter_num, 'chapter');
        }
        else this.routerPara();
      }
    },
    //跳转段落
    routerPara() {
      if (!this.needRouterPara) return;
      let that = $(`[data-id=${this.needRouterPara}]`);
      if (that && that.offset()) {
        let scrollTop = $(`.scroll-box`).scrollTop() + that.offset().top - 80;
        $('.scroll-box').animate({ scrollTop }, 300);
        this.needRouterPara = null;
      }
    },

    //组件销毁
    beforeUnmount() {
    }
  }
}


</script>

<style scoped lang="scss">
@import "./textbook-phone.scss";
</style>

<style>
.phone-box .box-view[data-margin="auto"] {
  margin-left: -30px !important;
  margin-right: -30px !important;
  border-radius: 0 !important;
  border-radius: 0 !important;
}
</style>